/* eslint-disable @angular-eslint/directive-selector */
import { Directive } from '@angular/core';

// Matching the tag names makes Angular treat them as known elements,
// so no CUSTOM_ELEMENTS_SCHEMA / NO_ERRORS_SCHEMA is needed.
@Directive({ selector: 'swiper-container', standalone: false })
export class SwiperContainerDirective {}

@Directive({ selector: 'swiper-slide', standalone: false })
export class SwiperSlideDirective {}